import BaseLayout from "../../../components/base_layout";
import { usePartsView } from "../../../hooks/usePartsView";
import PartsViewPc from "../../../components/parts/view/PartsViewPc";
import PartsViewMobile from "../../../components/parts/view/PartsViewMobile";
import PartsViewTablet from "../../../components/parts/view/PartsViewTablet";
// 전역변수
const axios = require("axios").default;

function PartView({ data }) {
  const parts = usePartsView(data);

  return (
    <BaseLayout>
      <PartsViewPc {...parts} />
      <PartsViewTablet {...parts} />
      <PartsViewMobile {...parts} />
    </BaseLayout>
  );
}

// This function gets called at build time
export async function getServerSideProps(context) {
  const { req, params, res } = context;
  const { cookies } = req;
  const code = params.code;
  const getdata = await axios.get(
    process.env.SEARCH_API_URL + "/search/detail/" + code,
    {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ` + cookies.token,
      },
    }
  );
  let data = [];

  if (getdata.data.status == 200) {
    data = getdata.data.data;
    data.code = code;
  } else {
    res.setHeader("location", "/");
    res.statusCode = 302;
    res.end();
  }

  // By returning { props: { posts } }, the Blog component
  // will receive `posts` as a prop at build time
  return {
    props: {
      data,
    },
  };
}

export default PartView;
